import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Cart Variant"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-cart-variant',
    templateUrl: './icon-cart-variant.component.html',
    styleUrls: ['./icon-cart-variant.component.scss'],
    standalone: false
})
export class IconCartVariantComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
